module.exports = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/months.json
 ** module id = 481
 ** module chunks = 0
 **/